<template>
  <div class="relative rounded-md overflow-hidden w-9 h-9">
    <img 
      v-if="src?.length"
      ref="image"
      :src="src" 
      alt="Ad Thumbnail" 
      class="w-full h-full"
      loading="lazy"
      decoding="async"
      @load="handleImageLoad"
    >
    <div v-else class="w-full h-full bg-neutral-25" />
    <transition>
      <div v-if="loadingImage && src?.length && !disableLoading" 
      class="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-neutral-800 opacity-40 z-50">
        <BaseLoadingSpinnerCircle class="text-white" :width="20" :height="20" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ThumbnailPreview',
  props: {
    src: {
      type: String,
      default: ''
    },
    disableLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loadingImage: true
    }
  },
  methods: {
    async handleImageLoad () {
      try {
        // Wait for actual decode completion
        await this.$refs.image.decode()
        this.loadingImage = false 
      } catch (error) {
        this.loadingImage = false
      }
    }
  }
}
</script>

<style scoped>
.v-leave-active {
  transition: opacity 200ms ease-in-out;
}
.v-leave-from {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
</style>